<template>
  <v-btn color="primary" class="elevation-0 ml-6" dark @click="onExport">
    <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel mẫu
  </v-btn>
</template>
<script>
import * as XLSX from 'xlsx'
import { setColumnWidths } from './utils'
import { IMPORT_SAMPLE_DATA, IMPORT_SAMPLE_FIELDS } from '../../helpers'
export default {
  methods: {
    onExport() {
      const formattedData = IMPORT_SAMPLE_DATA.map(item => {
        let formattedItem = {}
        for (let key in IMPORT_SAMPLE_FIELDS) {
          let value = item[IMPORT_SAMPLE_FIELDS[key]]

          if (key === 'Số điện thoại' && value) {
            formattedItem[key] = { v: value, t: 's' }
          } else {
            formattedItem[key] = value || ''
          }
        }
        return formattedItem
      })
      const worksheet = XLSX.utils.json_to_sheet(formattedData)
      setColumnWidths(worksheet, formattedData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Example Leads')
      XLSX.writeFile(workbook, 'example-danh-sach-khach-hang.xlsx')
    },
  },
}
</script>